import { gql } from "@apollo/client";

export const CREATE_GIVEN_CANS = gql`
  mutation CreateGivenCansMutation($input: CreateGivenCansInput!) {
    createGivenCans(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_GIVEN_CANS = gql`
  mutation UpdateGivenCansMutation($id: Int!, $input: UpdateGivenCansInput!) {
    updateGivenCans(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_GIVEN_CANS = gql`
  mutation RemoveGivenCansMutation($id: Int!) {
    removeGivenCans(id: $id) {
      ok
      error
    }
  }
`;

export const GIVEN_CANS = gql`
  query GivenCansQuery($id: Int!) {
    givenCans(id: $id) {
      ok
      error
      result {
        id
        productId
        quantity
        comment
        customerId
        givenBy {
          id
          firstname
          lastname
        }
      }
    }
  }
`;

export const GIVEN_CANS_LIST = gql`
  query GivenCansListQuery($where: GivenCansFiltersInput!) {
    givenCansList(where: $where) {
      ok
      error
      total
      results {
        id
        productId
        quantity
        comment
        customerId
        givenBy {
          id
          firstname
          lastname
        }
      }
    }
  }
`;
